// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Domain Fiyatları',
  subtitle: 'Domain uzantısı fiyatlarını yönetin',
  addNew: 'Yeni Fiyat Ekle',
  edit: 'Düzenle',
  extension: 'Uzantı',
  purchasePrice: 'Alış Fiyatı',
  salePrice: 'Satış Fiyatı',
  currency: 'Para Birimi',
  status: 'Durum',
  actions: 'İşlemler',
  noPrices: 'Henüz fiyat tanımlanmadı',
  noPricesDesc: 'İlk fiyatınızı ekleyerek başlayın.',
  priceAdded: 'Fiyat başarıyla eklendi',
  priceUpdated: 'Fiyat başarıyla güncellendi',
  priceDeleted: 'Fiyat başarıyla silindi',
  fetchError: 'Fiyatlar alınamadı',
  addError: 'Fiyat eklenemedi',
  updateError: 'Fiyat güncellenemedi',
  deleteError: 'Fiyat silinemedi',
  confirmDelete: 'Bu fiyatı silmek istediğinizden emin misiniz?',
  profit: 'Kar',
  listTitle: 'Domain Fiyat Listesi',
  addTitle: 'Yeni Domain Fiyatı Ekle',
  editTitle: 'Domain Fiyatı Düzenle',
  extensionPlaceholder: 'Örn: .com, .com.tr, .av.tr',
  extensionHint: 'Nokta ile başlayan uzantı (örn: .com)',
  addPrice: 'Fiyat Ekle',
  update: 'Güncelle',
  infoText: 'Domain uzantısına göre fiyat tanımlayın. Örneğin: .com, .com.tr, .av.tr, .org.tr gibi. Fatura eklerken domain seçildiğinde bu fiyatlar otomatik olarak getirilecektir.',
  gold: 'Altın'
};
